import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export interface BugReportPrefill {
  title?: string;
  actual?: string;
}

interface BugReportContextType {
  isOpen: boolean;
  prefill: BugReportPrefill;
  open: (prefill?: BugReportPrefill) => void;
  close: () => void;
}

const BugReportContext = createContext<BugReportContextType | undefined>(undefined);

export const useBugReport = (): BugReportContextType => {
  const context = useContext(BugReportContext);
  if (!context) throw new Error('useBugReport must be used within a BugReportProvider');
  return context;
};

export const BugReportProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [prefill, setPrefill] = useState<BugReportPrefill>({});

  const open = useCallback((next: BugReportPrefill = {}) => {
    setPrefill(next);
    setIsOpen(true);
  }, []);
  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo(() => ({ isOpen, prefill, open, close }), [isOpen, prefill, open, close]);
  return <BugReportContext.Provider value={value}>{children}</BugReportContext.Provider>;
};
